import React, { useEffect, useState } from 'react';
import { FormControl, TextField, Grid, Box, Card, CardContent, Typography, CardActions, Button } from '@mui/material/';
import axios from 'axios';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

import dayjs from 'dayjs'; // Assurez-vous d'importer dayjs

import FormLabel from '@mui/material/FormLabel';
import { AlignHorizontalRight, CommentsDisabledOutlined } from '@mui/icons-material';
import Cookies from 'js-cookie'

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import DialogYesNo from '../lib/dialog_yes_no';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import AppBar from '@mui/material/AppBar';
import { MenuItem, InputLabel, Select } from '@mui/material';

import { getSessionValide, getUserRule, getSessionExpirer, getIsAdmin } from '../../utils/userRule';

//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering

function Officers_edit({ recordId, clubid, secteur, addyear, actionTab, callback }) {

    //const [dateDebut, setDateDebut] = useState("");
    //const [dateFin, setDateFin] = useState("");
    // const [officerListState, setOfficerListState] = useState(null);
    const [isDisabledSave, setIsDisabledSave] = React.useState(true); // Désactivé par défaut

    const [errorAxios, setErrorAxios] = useState("false");
    const [isAdmin, setIsAdmin] = useState(false);
    const [openQuestion, setOpenQuestion] = React.useState(false);

    const [officerlist, setOfficerlist] = useState("");
    const [Memberslist, setMemberslist] = useState("");
    const [lookuplist, setLookuplist] = useState("");

    const [newOfficer, setnewOfficer] = React.useState({

        rowid: "new",
        fk_club_master: clubid,
        fk_lookup_officers: 0,// fk_id_titre du poste           
        Member_Club_Number: 0,
        Member_Roster_Number: 0,
        Effective_Date: formatDate(Date()),
        Date_Deleted: "2023-09-30",

    });








    const [currentTitre, setCurrentTitre] = React.useState("");
    const [tabValue, setTabValue] = React.useState(0);
    const [showTab1, setShowTab1] = React.useState(true);
    const [showTab2, setShowTab2] = React.useState(true);
    const [showTab3, setShowTab3] = React.useState(true);




    const [newRole, setNewRole] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');


    /*
       const MyAxios = axios.create({
           headers: { 'Access-Control-Allow-Origin':  process.env.REACT_APP_API},       
           withCredentials: true,
           xsrfCookieName: 'token',
           xsrfHeaderName: 'X-XSRF-TOKEN',
       })*/
    const MyAxios = axios.create({
        headers: {
            Authorization: "Bearer " + Cookies.get('token'),
        }
    })




    useEffect(() => {

        //**************** affichage du bon tab **************** */
        /*  if (recordId == "new") {
              setTabValue('1');
              setShowTab2(false);
              setShowTab3(false);
          }
          else {
              setTabValue('2');
              setShowTab1(false);
          }*/
        //******************************************************* */

        const fetchData = async () => {
            setIsAdmin(await getIsAdmin());
        };
        fetchData();
        LoadOfficer();

        MyAxios.get(process.env.REACT_APP_API + '/members/get/secteur/' + secteur + '/club/' + clubid + '/actifonly/true')
            .then((res) => {
                setMemberslist(res.data);



                MyAxios.get(process.env.REACT_APP_API + '/officers/get/lookup')
                    .then((res) => {
                        setLookuplist(res.data);
                        const OfficerLookup = res.data;



                        MyAxios.get(process.env.REACT_APP_API + "/officers/get/rid/" + recordId)
                            .then((res) => {

                                let items = {};
                                items["rowid"] = recordId;
                                items["Effective_Date"] = res.data[0].Effective_Date;
                                items["Date_Deleted"] = res.data[0].Date_Deleted;
                                items["fk_lookup_officers"] = res.data[0].fk_lookup_officers;
                                items["Member_Club_Number"] = res.data[0].fk_club_master;
                                items["Member_Roster_Number"] = res.data[0].Member_Roster_Number;

                                items["Effective_Date"] = res.data[0].Effective_Date;
                                items["Date_Deleted"] = res.data[0].Date_Deleted;


                                setnewOfficer(items);

                                //***************juste pour affichage .**** */
                                OfficerLookup.map((item, index) => {
                                    if (res.data[0].fk_lookup_officers == item['id']) {
                                        setCurrentTitre(item['Title']);
                                    }
                                });


                                //********************** *
                            })
                            .catch((error) => {

                            });




                    })
                    .catch((error) => {

                    });




            })
            .catch((error) => {

            });






    }, []);





    function LoadOfficer() {
        if (clubid !== "") {
            MyAxios.get(process.env.REACT_APP_API + '/officers/get/secteur/' + secteur + '/club/' + clubid + '/year/0')
                .then((res) => {
                    setErrorAxios(false);
                    const initialOfficerList = res.data;

                    MyAxios.get(process.env.REACT_APP_API + '/officers/get/secteur/' + secteur + '/club/' + clubid + '/year/1')
                        .then((additionalRes) => {
                            // Fusionnez les données des deux appels
                            const mergedOfficerList = [...initialOfficerList, ...additionalRes.data];

                            // Mettez à jour officerList avec les données fusionnées
                            setOfficerlist(mergedOfficerList);
                        })
                        .catch((error) => {
                            console.error("Erreur lors du deuxième appel AJAX :", error);
                            // En cas d'erreur, mettez à jour officerList avec les données initiales uniquement
                            setOfficerlist(initialOfficerList);
                        });
                    // setOfficerlist(res.data);
                    //console.log(officerlist);                    
                })
                .catch((error) => {
                    setErrorAxios(true);
                });
        }

    }

    const isValidDate = (dateString) => {
        // Vérifie que la chaîne correspond au format YYYY-MM-DD
        const regex = /^\d{4}-\d{2}-\d{2}$/;
        if (!regex.test(dateString)) {
            return false; // Le format est incorrect
        }

        // Crée un objet Date à partir de la chaîne
        const date = new Date(dateString);

        // Vérifie que la date est valide
        return (
            date instanceof Date &&
            !isNaN(date) &&
            date.toISOString().slice(0, 10) === dateString
        );
    };

    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }

    //****************************************************************************** */
    function setAnneeEnCours() {
        const today = new Date();
        const currentYear = today.getFullYear();
        const isAfterOctober = today.getMonth() >= 9; // Octobre = mois 9 (indexé à partir de 0)

        const startYear = isAfterOctober ? currentYear : currentYear - 1; // Année de début
        const endYear = isAfterOctober ? currentYear + 1 : currentYear;  // Année de fin

        const dateDebut = `${startYear}-10-01`; // Début de l'année (1er octobre)
        const dateFin = `${endYear}-09-30`;    // Fin de l'année (30 septembre)

        setDateDebut(dateDebut);
        setDateFin(dateFin);
    }

    function setDepuisMaintenantPourAnnee() {
        const today = new Date();
        const currentYear = today.getFullYear();
        const isAfterOctober = today.getMonth() >= 9;

        const endYear = isAfterOctober ? currentYear + 1 : currentYear; // Année de fin
        const dateDebut = formatDate(today); // Date actuelle
        const dateFin = `${endYear}-09-30`;  // Fin de l'année (30 septembre)

        setDateDebut(dateDebut);
        setDateFin(dateFin);
    }

    function setAnneeProchaine() {
        const today = new Date();
        const currentYear = today.getFullYear();
        const isAfterOctober = today.getMonth() >= 9;

        const startYear = isAfterOctober ? currentYear + 1 : currentYear; // Année de début
        const endYear = startYear + 1;                                   // Année de fin

        const dateDebut = `${startYear}-10-01`; // Début de l'année prochaine (1er octobre)
        const dateFin = `${endYear}-09-30`;     // Fin de l'année prochaine (30 septembre)

        setDateDebut(dateDebut);
        setDateFin(dateFin);
    }


    function setEndNow() {
        const today = new Date();
        const dateFin = formatDate(today); // Date actuelle

        // On garde la date de début inchangée
        setDateFin(dateFin);
    }
    function setEndYesterday() {
        const today = new Date();
        const yesterday = new Date(today); // Crée une copie de la date d'aujourd'hui
        yesterday.setDate(today.getDate() - 1); // Soustrait un jour pour obtenir hier

        const dateFin = formatDate(yesterday); // Formate la date d'hier

        // On garde la date de début inchangée
        setDateFin(dateFin);
    }




    //***************************************************************************** */
    function setDateDebut(MYValue) {

        console.log("1");

        let updatedOfficerTable = newOfficer;
        updatedOfficerTable["Effective_Date"] = MYValue;

        console.log(updatedOfficerTable);

        setnewOfficer(updatedOfficerTable);




        checkConflicts(
            updatedOfficerTable.rowid,
            updatedOfficerTable.Member_Roster_Number,
            updatedOfficerTable.fk_lookup_officers,
            updatedOfficerTable.Effective_Date,
            updatedOfficerTable.Date_Deleted
        );
        console.log("updatedOfficer", updatedOfficerTable);
        console.log("newOfficer", newOfficer);
        console.log("3");


    }
    function setDateFin(MYValue) {

        let updatedOfficerTable = newOfficer;
        updatedOfficerTable["Date_Deleted"] = MYValue;


        setnewOfficer(updatedOfficerTable);

        checkConflicts(
            updatedOfficerTable.rowid,
            updatedOfficerTable.Member_Roster_Number,
            updatedOfficerTable.fk_lookup_officers,
            updatedOfficerTable.Effective_Date,
            updatedOfficerTable.Date_Deleted
        );

    }
    //******************************************************************************************* */

    const checkConflicts = (rowId, Member_Roster_Number, role, startDate, endDate) => {
        setIsDisabledSave(false);
        const updatedList = officerlist.map(officer => {
            console.log("checkConflicts role:", officer.fk_lookup_officers, role);

            console.log(officer, officer.rid, rowId);
            if (officer.rid != rowId) // meme row ne pas valider
            {

                const conflict = (officer.fk_lookup_officers === role || officer.Member_Roster_Number === Member_Roster_Number) &&
                    (
                        // Cas 1 : La nouvelle plage commence avant ou pendant la plage existante et se termine après ou pendant la plage existante
                        (new Date(startDate) <= new Date(officer.Date_Deleted) && new Date(endDate) >= new Date(officer.Effective_Date)) ||

                        // Cas 2 : La nouvelle plage est entièrement contenue dans la plage existante
                        (new Date(startDate) >= new Date(officer.Effective_Date) && new Date(endDate) <= new Date(officer.Date_Deleted)) ||

                        // Cas 3 : La nouvelle plage commence avant la fin de la plage existante et se termine après la fin de la plage existante
                        (new Date(startDate) <= new Date(officer.Date_Deleted) && new Date(endDate) >= new Date(officer.Date_Deleted)) ||

                        // Cas 4 : La nouvelle plage commence avant le début de la plage existante et se termine après le début de la plage existante
                        (new Date(startDate) <= new Date(officer.Effective_Date) && new Date(endDate) >= new Date(officer.Effective_Date))
                    );

                if (conflict) {
                    setIsDisabledSave(true);
                    return { ...officer, hasConflict: true, currentRow: false };
                }
                else {
                    return { ...officer, hasConflict: false, currentRow: false };
                }
            }
            else {
                return { ...officer, hasConflict: false, currentRow: true };
            }
        });

        setOfficerlist(updatedList);

        console.log("checkConflicts officerlist:", updatedList);
    };



    //************************************************************************ */
    function handleDateChangeDebut(newValue) {

        if (!newValue || !dayjs(newValue).isValid()) return; // Vérifie que la nouvelle valeur est valide

        const formattedDate = formatDate(newValue); // Formate la date correctement

        setnewOfficer(prev => ({
            ...prev,
            Effective_Date: formattedDate
        }));

        let updatedOfficerTable = newOfficer;
        checkConflicts(
            updatedOfficerTable.rowid,
            updatedOfficerTable.Member_Roster_Number,
            updatedOfficerTable.fk_lookup_officers,
            formattedDate,
            updatedOfficerTable.Date_Deleted
        );

        // Vérifier si la date de fin existe et si elle est antérieure à la date de début
        if (newOfficer.Date_Deleted && dayjs(formattedDate).isAfter(dayjs(newOfficer.Date_Deleted))) {
            alert("La date de fin ne peut pas être antérieure à la date de début.");
            setIsDisabledSave(true);
            return;
        }

    }

    function handleDateChangeDelete(newValue) {

        if (!newValue || !dayjs(newValue).isValid()) return; // Vérifie que la nouvelle valeur est valide

        const formattedDate = formatDate(newValue);
        setnewOfficer(prev => ({
            ...prev,
            Date_Deleted: formattedDate
        }));

        let updatedOfficerTable = newOfficer;
        checkConflicts(
            updatedOfficerTable.rowid,
            updatedOfficerTable.Member_Roster_Number,
            updatedOfficerTable.fk_lookup_officers,
            updatedOfficerTable.Effective_Date,
            formattedDate
        );

        // Vérifier si la date de fin existe et si elle est antérieure à la date de début
        if (newOfficer.Date_Deleted && dayjs(formattedDate).isAfter(dayjs(newOfficer.Date_Deleted))) {
            alert("La date de fin ne peut pas être antérieure à la date de début.");
            setIsDisabledSave(true);
            return;
        }

    }

    //************************************************************************ */
    function handleChangeTitleOfficer(event) {


        const value = event.target.value;
        setnewOfficer(prev => ({
            ...prev,
            fk_lookup_officers: value
        }));

        let updatedOfficerTable = newOfficer;
        checkConflicts(
            updatedOfficerTable.rowid,
            updatedOfficerTable.Member_Roster_Number,
            value,
            updatedOfficerTable.Effective_Date,
            updatedOfficerTable.Date_Deleted
        );

    }

    function handleChangeOfficer(event) {

        const value = event.target.value;
        setnewOfficer(prev => ({
            ...prev,
            Member_Roster_Number: value
        }));

        let updatedOfficerTable = newOfficer;
        checkConflicts(
            updatedOfficerTable.rowid,
            value,
            updatedOfficerTable.fk_lookup_officers,
            updatedOfficerTable.Effective_Date,
            updatedOfficerTable.Date_Deleted
        );



    }
    function SaveChange() {


        MyAxios.post(process.env.REACT_APP_API + '/officers/addUpdate/' + clubid, newOfficer, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then((res) => {
                console.log(res)
                if (res.status === 200) {
                    alert("Sauvegarde complété");

                    if (typeof (callback) != undefined) {
                        console.log("Do callBack..");
                        callback();
                    }
                }
                else if (res.status === 201) {
                    console.log(res);
                    alert(res.data[0]);
                }
            })
            .catch((error) => {
                console.log(error);
                alert(error);
            });


    }

    function onCloseDialog() {
        setOpenQuestion(false);
    }
    function DeleteOfficerModal() {
        setOpenQuestion(true);
    }


    function DeleteOfficer(response) {

        if (response === true) {


            MyAxios.get(process.env.REACT_APP_API + '/officers/delete/' + recordId)
                .then((res) => {
                    alert("Suppression complété");

                    if (typeof (callback) != undefined) {
                        console.log("Do callBack..");
                        callback();
                    }
                })
                .catch((error) => {
                    alert("Seul un administrateur système peut supprimer un dirigeant en place.");
                });

        }
    }



    function getButtonSupprimer() {

        if (isAdmin === true)
            return <Button onClick={DeleteOfficerModal} sx={{ m: 1, border: '1px solid red' }} variant="outlined" >SUPPRIMER</Button>;

    }


    /*
        const handleChangeTab = (event, newValue) => {
            setTabValue(newValue);
        };
        
        <Tabs
                                indicatorColor="secondary"
                                textColor="inherit"
                                variant="fullWidth"
                                aria-label="full width tabs example"
                                value={tabValue} onChange={handleChangeTab} centered
                            >
                                {showTab1 && <Tab value="Nouveau" label="Ajouter un dirigeant" />}
                                {showTab2 && <Tab value="Remplacant" label="Terminer le mandat de Pierre et inscrire son remplacant" />}
                               
    
    
                            </Tabs>
    */
    return (


        <div>
            <Grid container direction="row" spacing={2} sx={{ maxWidth: '950px' }} >

                <Grid item xs={12} >

                    <>

                        <Grid container item xs={12} style={{ padding: '8px', display: 'flex', alignItems: 'center', width: '100%', fontWeight: 'bold', borderBottom: '1px solid #000' }}>
                            <Grid item xs>
                                <Typography component="h6">Titre</Typography>
                            </Grid>
                            <Grid item xs>
                                <Typography component="h6">Nom</Typography>
                            </Grid>
                            <Grid item xs>
                                <Typography component="h6">Effectif</Typography>
                            </Grid>
                            <Grid item xs>
                                <Typography component="h6">Début</Typography>
                            </Grid>
                            <Grid item xs>
                                <Typography component="h6">Fin</Typography>
                            </Grid>
                        </Grid>

                        {Object.entries(officerlist).map(([key, value]) => (




                            <Grid container item xs={12} key={key} style={{
                                padding: '8px', display: 'flex', alignItems: 'center', width: '100%',
                                backgroundColor: value.hasConflict ? "pink" : value.currentRow ? "lightgreen" : 'transparent'
                            }}>

                                <Grid item xs>
                                    <Typography component="h6" style={{ fontWeight: 'bold' }}>
                                        {value.Title}
                                    </Typography>
                                </Grid>
                                <Grid item xs>
                                    <Typography variant="subtitle1" component="p" style={{ fontSize: '1.1rem' }}>
                                        {value.First_Name} {value.Last_Name}
                                    </Typography>
                                </Grid>
                                <Grid item xs>
                                    <Typography variant="body1" color="textSecondary" style={{ fontSize: '1rem' }}>
                                        Effectif: {value.effectif}
                                    </Typography>
                                </Grid>
                                <Grid item xs>
                                    <Typography variant="body2" color="textSecondary">
                                        Début: {value.Effective_Date}
                                    </Typography>
                                </Grid>
                                <Grid item xs>
                                    <Typography variant="body2" color="textSecondary">
                                        Fin: {value.Date_Deleted}
                                    </Typography>
                                </Grid>
                            </Grid>
                        ))}

                        <Grid container item xs={12} style={{ marginBottom: '12px', display: 'flex', alignItems: 'center', width: '100%', borderBottom: '1px solid #000' }}>
                        </Grid>

                        <Typography variant="h6">Ajouter un nouveau dirigeant</Typography>


                        <FormControl fullWidth sx={{ my: 2 }}>
                            <InputLabel id="TitleLabel2">Nom du dirigeant</InputLabel>
                            <Select
                                label="Nom du dirigeant"
                                value={newOfficer['Member_Roster_Number']}
                                onChange={(e) => handleChangeOfficer(e)}>

                                {Object.entries(Memberslist).map(([key, value]) => (
                                    <MenuItem value={value.Member_Roster_Number}>{value.First_Name + " " + value.Last_Name} </MenuItem>
                                ))}

                            </Select>
                        </FormControl>


                        <FormControl fullWidth sx={{ my: 2 }}>
                            <InputLabel id="TitleLabel2">Rôle</InputLabel>
                            <Select
                                label="Rôle"

                                value={newOfficer['fk_lookup_officers']}
                                onChange={(e) => handleChangeTitleOfficer(e)}>

                                {Object.entries(lookuplist).map(([key, value]) => (
                                    <MenuItem value={value.id}>{value.Title} </MenuItem>
                                ))}


                            </Select>
                        </FormControl>
                        <Grid container justifyContent="center" >

                            <Button variant="containedThird" sx={{ m: 1 }} color="primary" onClick={() => setEndNow()}>
                                Terminer le mandat aujourd'hui
                            </Button>
                            <Button variant="containedThird" sx={{ m: 1 }} color="primary" onClick={() => setEndYesterday()}>
                                Terminer le mandat hier
                            </Button>
                            <Button variant="containedThird" sx={{ m: 1 }} color="primary" onClick={() => setAnneeEnCours()}>
                                Année en cours
                            </Button>
                            <Button variant="containedThird" sx={{ m: 1 }} color="primary" onClick={() => setDepuisMaintenantPourAnnee()}>
                                Débute maintenant et pour le reste de l'année
                            </Button>
                            <Button variant="containedThird" sx={{ m: 1 }} color="primary" onClick={() => setAnneeProchaine()}>
                                Année prochaine
                            </Button>
                        </Grid>

                        <Grid container justifyContent="center" >
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='fr'>

                                <DatePicker
                                    id="MyYear"
                                    label="Date début"
                                    key="dateDebut"
                                    name="Effective_Date"
                                    inputFormat="YYYY-MM-DD"
                                    value={newOfficer['Effective_Date']}
                                    onChange={(newValue) => {
                                        // Vérifier si la date de fin devient invalide

                                        handleDateChangeDebut(newValue);


                                    }
                                    }
                                    renderInput={(params) => <TextField {...params} />}
                                />


                                <DatePicker
                                    key='datefin'
                                    name="Date_Deleted"
                                    label="Date fin"
                                    inputFormat="YYYY-MM-DD"
                                    value={newOfficer['Date_Deleted']}
                                    onChange={(newValue) => {
                                        handleDateChangeDelete(newValue);

                                    }}

                                    renderInput={(params) => <TextField {...params} />}
                                />


                            </LocalizationProvider>
                        </Grid>

                        <hr />

                        <Grid container justifyContent="flex-end">
                            <Button
                                onClick={SaveChange}
                                sx={{
                                    m: 1,
                                    bgcolor: isDisabledSave ? "grey.500" : "primary.contrastText",

                                }}
                                variant="containedFifth"
                                disabled={isDisabledSave}>ENREGISTRER</Button>
                        </Grid>

                    </>


                </Grid>
            </Grid>
            <DialogYesNo question="Voulez-vous vraiment supprimer ce dirigeant?" onAnswer={DeleteOfficer} open={openQuestion} onClose={onCloseDialog} />

        </div>



    );

}

export default Officers_edit;